<script>
    import { setBookAccordionDeps } from './context.js';

    /**
     * @typedef {Object} Access
     * @property {(role: string) => boolean} hasRole
     * @property {(action: string) => boolean} hasContentAction
     * @property {(resource: any) => boolean} canAccessResource
     * @property {(material: any) => boolean} canAccessTeacherOnlyMaterial
     * @property {{ subscribe: Function }} currentUser
     */

    /**
     * @typedef {Object} Db
     * @property {Function} getEntity
     * @property {Function} getEntityBreadcrumb
     * @property {Function} getEntitiesWhere
     * @property {Function} getFirestore
     * @property {import('firebase/firestore').Firestore} [contentDb] - content-db instance for read-only-titles docPath reads
     */

    /**
     * @typedef {Object} Fns
     * @property {Function} callable
     */

    /**
     * @typedef {Object} Features
     * @property {() => boolean} [isContentVisibilityEnabled]
     */

    /**
     * @typedef {Object} Props
     * @property {Access} access
     * @property {Db} db
     * @property {Fns} [functions]
     * @property {Features} [features]
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let { access, db, functions, features, children } = $props();

    setBookAccordionDeps({ access, db, functions, features });
</script>

{@render children?.()}
